import React from "react"
import { Footer, SEO, Layout } from '@components'
import Hero from '@components/pages/keyboard-shortcuts/Hero.js'
import Content from '@components/pages/keyboard-shortcuts/Content.js'

const KeyboardShortcuts = () => {
    return (
        <>
      <Layout>
        <SEO
          title="Dynobase Keyboard Shortcuts"
          description="Speed-up your DynamoDB Workflow with Dynobase's keyboard shortcuts"
          noIndex
        />
        <div
          style={{
            margin: "auto",
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
                >
          <Hero />  
          <Content />
          <Footer />
        </div>
      </Layout>
    </>
    )
}

export default KeyboardShortcuts